
import { Helmet } from "react-helmet";
import LaserDentistryPage from "@/components/services/laser-dentistry/LaserDentistryPage";

const LaserDentistry = () => {
  return (
    <>
      <Helmet>
        <title>Laser Dentistry in Nagpur | Cost of Laser Dentistry in Nagpur</title>
        <meta
          name="description"
          content="Get advanced laser dentistry treatments in Nagpur at Asrani Dental Clinic. Painless, precise procedures for gum treatment, cavity removal, and more."
        />
      </Helmet>
      
      <LaserDentistryPage />
    </>
  );
};

export default LaserDentistry;
